import { type ReactNode, useCallback, useId } from 'react';
import Check from '@/assets/icons/Check.svg';
import { ConditionalWrapper } from '@/components/ConditionalWrapper';
import * as Styled from './Checkbox.styled';

interface CheckboxProps {
  helpText?: string;
  isOffset?: boolean;
  isSelected?: boolean;
  label: ReactNode;
  name?: string;
  onChange?: (value: boolean) => void;
  slot?: string;
}

export const Checkbox = ({
  helpText,
  isOffset = false,
  label,
  ...deferred
}: CheckboxProps) => {
  const helpTextId = useId();
  const additionalProps = {
    ...(helpText ? { 'aria-describedby': helpTextId } : {}),
  };

  const Wrapper = useCallback(
    (children: ReactNode) => <Styled.Wrapper>{children}</Styled.Wrapper>,
    [],
  );

  return (
    <ConditionalWrapper condition={isOffset} wrapper={Wrapper}>
      <Styled.Checkbox {...deferred} {...additionalProps}>
        <div className="checkbox">
          <Check />
        </div>
        {label}
      </Styled.Checkbox>
      {helpText ? (
        <Styled.HelpText id={helpTextId}>{helpText}</Styled.HelpText>
      ) : null}
    </ConditionalWrapper>
  );
};
